import { el, mount, unmount, setAttr } from 'redom';
import DOMPurify from 'dompurify';

import SourceFileInput from './input';
import CodePreviewToggleButton from './code-preview-toggle-button';

import { renderInIframe } from './utilities';

class SourceCodeEditor {

  constructor(configuration) {

    this.files = configuration.files;
    this.onChange = configuration.onChange;

    this.sourceFilesNavigator = null;
    this.sourceFileInput = null;
    this.sourceFileInputContainer = null;
    this.codePreview = el('.code-preview-main');

    this.el = el('.source-code-editor-main', {
      contenteditable: false,
      onblur: this.stopPropagation.bind(this),
      onkeyup: this.stopPropagation.bind(this),
      onpaste: this.stopPropagation.bind(this),
      oninput: this.stopPropagation.bind(this)
    }, [
      this.renderCodePreviewToggleButton(),
      this.renderSourceFileInput()
    ]);

  }

  renderCodePreviewToggleButton() {

    const button = new CodePreviewToggleButton({
      onCode: this.displayCode.bind(this),
      onPreview: this.displayPreview.bind(this)
    });

    return button;

  }

  renderSourceFileInput() {

    this.sourceFileInput = new SourceFileInput({
      file: this.files[0],
      onChange: this.handleFileChange.bind(this)
    });

    this.sourceFileInputContainer = el('.source-input-container', this.sourceFileInput);

    return this.sourceFileInputContainer;

  }

  displayCode() {

    this.codePreview.innerHTML = '';

    unmount(this.el, this.codePreview);
    mount(this.el, this.sourceFileInputContainer);

  }

  displayPreview() {

    renderInIframe(this.codePreview, this.files[0].content);

    unmount(this.el, this.sourceFileInputContainer);
    mount(this.el, this.codePreview);

  }

  stopPropagation(event) {

    event.stopPropagation();

  }

  handleFileChange(file) {

    this.files = [{ ...file }];

    this.onChange([file]);

  }

  update(configuration) {

    this.files = configuration.files;

    this.sourceFileInput.update({ file: this.files[0] });

  }

  onmount() {

    this.displayPreview();

  }

}

export default SourceCodeEditor;